<form autocomplete="off" novalidate [formGroup]="ExamAggForm">
    <div *ngIf="submitButton">
        <h4 class="main-content-label mb-1"><b>
                <!-- {{'header.exam-aggregate.titleList.AddNewExamAggregateRecord' |
                translate}} -->
                Add Exam Aggregate Record
            </b></h4>
        <!-- <p class="text-muted card-sub-title mb-0">
            {{'header.exam-aggregate.titleList.AddNewExamAggregateInformation' |
            translate}}
        </p> -->
    </div>
    <div *ngIf="deleteButton">
        <h4 class="main-content-label mb-1"><b>
                <!-- {{'header.exam-aggregate.titleList.DeleteExamAggregateRecord' |
                translate}} -->
                Delete Exam Aggregate Record
            </b></h4>
        <!-- <p class="text-muted card-sub-title mb-0">
            {{'header.exam-aggregate.titleList.DeleteSelectedExamAggregateInformation' |
            translate}}</p> -->
    </div>
    <div class="row clearfix mt-3">
        <div class="col-sm-4">
            <div class="form-group">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>Exam Name</mat-label>
                        <input readonly style="color:black;" matInput formControlName="EaEmName">
                    </mat-form-field>
            </div>
        </div>
        <div *ngIf="isShowExamCode==true" class="col-sm-4">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>{{'header.exam-aggregate.titleList.ExamCode'
                            | translate}}</mat-label>
                        <mat-select required [disabled]="isreaddelete" onkeydown="return (event.keyCode!=13);" #select55 class="colorblack" formControlName="EaAgEmId">
                            <mat-select-filter *ngIf="select55.focused" [placeholder]="'Filter'"
                                [displayMember]="'EmName'" [array]="CodeList"
                                (filteredReturn)="filteredListCode =$event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredListCode" [value]="item.EmId">
                                {{item.EmCode}} - {{item.EmName}}
                            </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaAgEmId'].touched && ExamAggForm.controls['EaAgEmId'].errors?.required">
                            This Field Is Mandatory
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div *ngIf="isShowDesc==true" class="col-sm-4">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{'header.exam-aggregate.titleList.Description'
                            | translate}}
                        </mat-label>
                        <input required [readonly]="isreaddelete" onkeydown="return (event.keyCode!=13);" maxlength="50" class="color" matInput formControlName="EaDesc" placeholder="Description">
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaDesc'].touched && ExamAggForm.controls['EaDesc'].errors?.required">
                           This Field Is Mandatory
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div *ngIf="isShowPartAggr==true" class="col-sm-4">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{'header.exam-aggregate.titleList.PartAgg'
                            | translate}}
                        </mat-label>
                        <input required [readonly]="isreaddelete" onkeydown="return (event.keyCode!=13);" maxlength="5" class="color" matInput formControlName="EaOutOf" placeholder="Partial Aggregate">
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaOutOf'].touched && ExamAggForm.controls['EaOutOf'].errors?.required">
                            This Field Is Mandatory
                         </mat-error>
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaOutOf'].touched && ExamAggForm.controls['EaOutOf'].errors?.pattern">
                            Please Enter Valid Data
                        </mat-error>
                    </mat-form-field>
                    
                </div>
            </div>
        </div>
        <div *ngIf="isShowWeight==true" class="col-sm-4">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{'header.exam-aggregate.titleList.Weight'
                            | translate}}
                        </mat-label>
                        <input required [readonly]="isreaddelete" onkeydown="return (event.keyCode!=13);" maxlength="5" class="color" matInput formControlName="EaWeight" placeholder="weight">
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaWeight'].touched && ExamAggForm.controls['EaWeight'].errors?.required">
                            This Field Is Mandatory
                         </mat-error>
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaWeight'].touched && ExamAggForm.controls['EaWeight'].errors?.pattern">
                            Please Enter Valid Data
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div *ngIf="isShowToWeight==true" class="col-sm-4">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{'header.exam-aggregate.titleList.TotWght'
                            | translate}}
                        </mat-label>
                        <input [readonly]="isreaddelete" onkeydown="return (event.keyCode!=13);" maxlength="5" class="color" matInput formControlName="EaTotWeight" placeholder="Total Weight" required>
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaTotWeight'].touched && ExamAggForm.controls['EaTotWeight'].errors?.required">
                            This Field Is Mandatory
                         </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!-- <div class="col-sm-4">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{'header.exam-aggregate.titleList.SubTot'
                            | translate}}
                        </mat-label>
                        <input [readonly]="isreaddelete" onkeydown="return (event.keyCode!=13);" maxlength="5" class="color" matInput formControlName="EaSubTot" placeholder="Sub Total">
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaSubTot'].touched && ExamAggForm.controls['EaSubTot'].errors?.pattern">
                            Please Enter Valid Data
                        </mat-error>
                    </mat-form-field>
                   
                </div>
            </div>
        </div> -->
        <div class="col-sm-2 mt-3" *ngIf="SubTotal">
            <mat-checkbox class="example-margin" [disabled]="isreaddelete" formControlName="EaSubTot">
                SubTotal: {{SubValue}} ?
            </mat-checkbox>
        </div>
        <div class="col-sm-4" *ngIf="ExamAFormArray['EaSpFlag'][0]['FormVisible']">
            <div class="form-group">
                <div class="">
                    <mat-form-field appearance="outline" class="example-full-width" >
                        <mat-label>
                            {{ExamAFormArray['EaSpFlag'][0]['FormDisplayName']}}
                            <span *ngIf="ExamAFormArray['EaSpFlag'][0]['FormRequired']">*</span>
                        </mat-label>
                        <input [readonly]="isreaddelete" onkeydown="return (event.keyCode!=13);" maxlength="5" class="color" matInput formControlName="EaSpFlag" placeholder="Ledger">
                        <mat-error class="margin_tp" *ngIf="ExamAggForm.controls['EaSpFlag'].touched && ExamAggForm.controls['EaSpFlag'].errors?.pattern">
                            Please Enter Valid Data
                        </mat-error>
                        <mat-error class="margin_tp"
                        *ngIf="ExamAggForm.controls['EaSpFlag'].touched && ExamAggForm.controls['EaSpFlag'].errors?.required">
                        This Field Is Mandatory
                        </mat-error>
                    </mat-form-field>
                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8"></div>
            <div class="col-sm-2 pri-0">
                <button type="button"
                    class="btn size btn-primary btn-icon-text floatright mt-1"
                    (click)="back()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/turn-left.gif"
                            style="margin-right: 5px;">
                        Back
                    </span>
                </button>
            </div>
            <div class="col-sm-2 pri-0" *ngIf="submitButton && ExAgCreate">
                <button type="button"
                    class="btn size btn-primary btn-icon-text floatleft mt-1"
                    (click)="submit()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/save.gif"
                            style="margin-right: 5px;">
                        Save
                    </span>
                </button>
            </div>
            <div class="col-sm-2 pri-0" *ngIf="deleteButton && ExAgDelete">
                <button type="button"
                    class="btn size btn-primary btn-icon-text floatleft mt-1"
                    (click)="openConformationModalBox()">
                    <span style="display: contents; align-items: center;">
                        <img width="20vh" src="../../assets/img/trash.gif"
                            style="margin-right: 5px;">
                        Delete
                    </span>
                </button>
            </div>
           
            <!-- <button type="button" class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                *ngIf="submitButton && ExAgCreate" (click)="submit()">
                {{'header.exam-aggregate.titleList.Submit' | translate}}
            </button> -->
            <!-- <button type="submit" class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                (click)="addnewrecord('false')">
                {{'header.exam-aggregate.titleList.New' | translate}}
            </button> -->
            <!-- <button type="button"
            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
            *ngIf="deleteButton && ExAgDelete" (click)="openConformationModalBox()">
            {{'header.exam-aggregate.titleList.Delete' | translate}}
            </button>
            <button type="button"
                class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                (click)="back()">
                {{'header.exam-aggregate.titleList.Back' | translate}}
            </button> -->
        </div>
    </div>
    <hr  *ngIf="showTable">
    <div  *ngIf="showTable">
        <h4 class="main-content-label mb-1">
            <b>
                {{'header.exam-aggregate.titleList.List'|translate}}
            </b>
        </h4>
        <!-- <p class="text-muted card-sub-title mb-0">
            Exam Aggregate Data </p> -->
    </div>
    <hr  *ngIf="showTable">
    <div  *ngIf="showTable" class="table-responsive mt-4">
        <table id="datatable" class="table table-bordered text-nowrap">
            <thead>
                <tr class="text-left">
                    <!-- <th class="f600">
                        {{'header.exam-aggregate.table.ExamCode' | translate}}
                    </th> -->
                    <th class="f600">
                        {{'header.exam-aggregate.table.Description' | translate}}
                    </th>
                    <th class="f600" *ngIf="isShowPartAggr==true">
                        {{'header.exam-aggregate.table.PartAgg' | translate}}
                    </th>
                    <th class="f600" *ngIf="isShowWeight==true">
                        {{'header.exam-aggregate.table.Weight' | translate}}
                    </th>
                    <th class="f600" *ngIf="isShowToWeight==true">
                        {{'header.exam-aggregate.table.TotWght' | translate}}
                    </th>
                    <th class="f600">
                        {{'header.exam-aggregate.table.SubTot' | translate}}
                    </th>
                    <th class="f600">
                        {{'header.exam-aggregate.table.Ledger' | translate}}
                    </th>
                    <th class="f600 text-center">
                        {{'header.exam-aggregate.table.Action' | translate}}
                    </th>

                </tr>
            </thead>



            <tbody id="table_data">
                <tr *ngFor="let examagg of examaggList;">

                    <!-- <td> {{examagg.EaEmCode}} </td> -->
                    <td>{{examagg.EaDesc}} </td>
                    <td *ngIf="isShowPartAggr==true">{{examagg.EaOutOf}} </td>
                    <td *ngIf="isShowWeight==true">{{examagg.EaWeight}} </td>
                    <td *ngIf="isShowToWeight==true"> {{examagg.EaTotWeight}} </td>
                    <td>{{examagg.EaSubTot}} </td>
                    <td>{{examagg.EaSpFlag}} </td>
                    <td class="text-center">
                        <a class="btn-floating" title="Delete" (click)="deletee('true',examagg)">
                            <i class="fas fa-trash"></i>

                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</form>